module.exports = __webpack_public_path__ + "media/images/przedszkole6-a913127d8a625fc3ad1f186f1852a657.png";